
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
export default {
data (){
return {
picList:[],
titleList:[],
srcs:'',
show_1:false,
openid:'',
comnCode:'',
feeCode:'',
shos:false,
msg:'',
hsNo:'',
hsName:'',
mainPhone:'',
phone:'',
hsName:''
}
},
components:{
Flexbox,
FlexboxItem,
XInput,
XNumber,
XButton,
loadPage,
Alert

},
beforeMount(){
if(this.$router.history.current.path == "/feePayment"){
document.title = "费用缴纳";
}
this.openid = this.$router.history.current.query.openid;
this.comnCode = this.$router.history.current.query.comnCode;


this.show_1 = true;
let usInfo = new Object();
usInfo.comnCode = this.comnCode;
usInfo.openId = this.openid;
let url = global.host + 'temporaryCharge/init';
this.$http.post(url,usInfo).then(function(res){

let results = res.body.success;
let picList = res.body.result;
var rows = '';
if(results){
for(var key in picList){
for(var key1 in picList[key]){
rows += ("<h1>"+key1+"</h1>");
var mn = picList[key][key1];
for(var i=0;i<mn.length;i++){
rows += ("<li class='am_flexItem mout' id='"+mn[i].feeCode+"' configId ='"+mn[i].configId+"' feeType = '"+mn[i].feeType+"'>" );
rows += ("<img src='"+mn[i].configIcon+"'>");
rows += ("<strong>"+mn[i].configName+"</strong>");
rows += ("</li>");
}

}

}
$(".am_conFent").append(rows)
}

this.show_1 = false;
},function(err){
console.log(err)
})
},
mounted(){

let selfs = this;
$(".am_conFent").delegate("li","click",function(){

selfs.feeCode =$(this).attr("id");
selfs.configId = $(this).attr("configId");
selfs.feeType = $(this).attr("feeType");
if(selfs.feeType == "02"){
selfs.turTart();
}else if(selfs.feeType == "05"){
selfs.zxAjax();
}

})
},
methods:{
turTart(){//临时费用
this.show_1 = true;
let usInfo1 = new Object();
usInfo1.comnCode = this.comnCode;
usInfo1.openId = this.openid
let url = global.host + 'temporaryCharge/checkdecorate';
this.$http.post(url,usInfo1).then(function(res){

if(res.body.success == true){
this.phone = res.body.result.phone;
this.hsName = res.body.result.hsName;
this.hsNo = res.body.result.hsNo;

let usIn = new Object();
usIn.comnCode = this.comnCode;
usIn.openId = this.openid;
usIn.feeCode = this.feeCode;
console.log(usIn)
let url = global.host + 'temporaryCharge/initTemporary';
this.$http.post(url,usIn).then(function(res){

let picList = res.body.result.calType;
if(picList == '1'){
this.$router.push({path:'/relatedToNumber',query:{openId:this.openid,mainPhone:this.phone,feeCode:res.body.result.feeCode,price:res.body.result.price,calType:picList,feeNum:res.body.result.feeNum,comnCode:res.body.result.comnCode,feeMoney:res.body.result.feeMoney,feeName:res.body.result.feeName,hsNo:this.hsNo,hsName:this.hsName}});
}else if(picList == '0'){
this.$router.push({path:'/customAmout',query:{openId:this.openid,mainPhone:this.phone,feeCode:res.body.result.feeCode,calType:picList,feeMoney:res.body.result.feeMoney,feeName:res.body.result.feeName,comnCode:res.body.result.comnCode,feeNum:res.body.result.feeNum,hsNo:this.hsNo,hsName:this.hsName}});
}else{
this.shos = true;
this.msg = '该收费项，暂未开放';
}
this.show_1 = false;
},function(err){
console.log(err)
})


}

this.show_1 = false;
},function(err){
console.log(err)
})
},
anHides(){
this.$router.push({path:'/decorationCost',query:{feeCode:this.feeCode,hsNo:this.hsNo,hsName:this.hsName,mainPhone:this.mainPhone,configId:this.configId,openId:this.openid,comnCode:this.comnCode}});
},
zxAjax(){//装修押金
this.show_1 = true;
let usInfo1 = new Object();
usInfo1.comnCode = this.comnCode;
usInfo1.openId = this.openid
let url = global.host + 'temporaryCharge/checkdecorate';
this.$http.post(url,usInfo1).then(function(res){
let flags = res.body.result.flag;
let picList = res.body.success;
this.hsNo = res.body.result.hsNo;
this.hsName = res.body.result.hsName;
this.mainPhone = res.body.result.phone;

if(picList == true){
this.$router.push({path:'/decorationCost',query:{feeCode:this.feeCode,hsNo:this.hsNo,hsName:this.hsName,mainPhone:this.mainPhone,configId:this.configId,openId:this.openid,comnCode:this.comnCode}});
/*if(flags == 0){
this.shos = true;
this.msg = res.body.result.msg;
}else if(flags == 1){
this.$router.push({path:'/decorationCost',query:{feeCode:this.feeCode,hsNo:this.hsNo,hsName:this.hsName,mainPhone:this.mainPhone,configId:this.configId,openId:this.openid,comnCode:this.comnCode}});
}*/
}

this.show_1 = false;
},function(err){
console.log(err)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/temporaryCharge/feePayment.vue